export default {
  POST_DETAIL_LIST_REQUEST: 'APP/POST_DETAIL/POST_DETAIL_LIST_REQUEST',
  POST_DETAIL_LIST_SUCCESS: 'APP/POST_DETAIL/POST_DETAIL_LIST_SUCCESS',
  POST_DETAIL_LIST_ERROR: 'APP/POST_DETAIL/POST_DETAIL_LIST_ERROR',
};
